module.exports = __webpack_public_path__ + "media/application/images/ui/badge-trusted-with-text-4b2be61090ae3f68e5286b9c89846e66.png";